<template>
  <div class="social">
    <a :href="media.link" target="_blank"
      ><i :class="media.icon" :style="color"
    /></a>
  </div>
</template>

<script>
export default {
  computed: {
    color() {
      if (this.media.color) {
        return `color: ${this.media.color}`;
      } else {
        return `color: black`;
      }
    },
  },
  props: {
    media: {
      color: String,
      icon: String,
      link: String,
      style: String,
    },
  },
};
</script>
"

<style scoped>
.social {
  display: inline-block;
}

i {
  font-size: calc(2rem + 0.3vw);
  margin: 0.25rem;
}
</style>
